import {createActionGroup} from '@ngrx/store';
import {PAGINATION_FEATURE_KEY, PaginationInfo} from '@store/pagination/pagination.types';

export const PaginationActions = createActionGroup({
  source: PAGINATION_FEATURE_KEY,
  events: {
    'Update': (info: PaginationInfo) => ({info})
  },
});
